export enum GradeKey {
  A_GRADE = 'A_GRADE',
  HASH = 'HASH',
  B_GRADE = 'B_GRADE',
  C_GRADE = 'C_GRADE',
  S_GRADE = 'S_GRADE'
}

export interface GradeConfig {
  key: GradeKey
  display: string
  qualityCode: string
  needsReason: boolean
}

export interface GradeReasonProperties {
  grade: string
  display: string
  sequence: number
  reasonCode: string
  reason: string
  qualityCode: string
  refundApprovalRasnChannels: string[]
  refundColorsOn?: boolean
  isegCode: string
  isSpecialInstruction?: boolean
}

export const getGradeReasons = (grade: GradeKey, gradeProperties: GradeReasonProperties[]) => {
  const filteredGradeReasonProperties: GradeReasonProperties[] = []
  gradeProperties.filter(gp => gp.grade === grade?.valueOf()).forEach(gp => filteredGradeReasonProperties.push(gp))

  return filteredGradeReasonProperties.sort((a, b) => a.sequence - b.sequence)
}
export const getGradeConfig = (grade: GradeKey, gradeConfigs: GradeConfig[]): GradeConfig | undefined => {
  return gradeConfigs.find(gradeConfig => gradeConfig.key === grade?.valueOf())
}
export const emptyGradeReasonProperties: GradeReasonProperties = {
  grade: '',
  display: '',
  sequence: 0,
  reason: '',
  reasonCode: '',
  qualityCode: '',
  refundApprovalRasnChannels: [],
  refundColorsOn: false,
  isegCode: ''
}
